module.exports = __webpack_public_path__ + "img/81.bd22ac1f.jpg";